import { useMutation } from "@tanstack/react-query";
import { deleteUserAccount } from "api/delete-user-account";

export function useDeleteAccount() {
  const mutation = useMutation({
    mutationFn: deleteUserAccount,
    // This is a mock function to simulate the API call
    // eslint-disable-next-line no-promise-executor-return, @typescript-eslint/no-unused-vars
    // mutationFn: (userId?: string) => new Promise((r) => setTimeout(r, 2000)),
  });
  return mutation;
}
